// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import VolumeMutedIcon from '../../../../assets/images/volume-muted.svg';

const S = {
  VolumeContainer: styled.div`
    display: flex;
    position: relative;
  `,
  VolumeBarDetectArea: styled.div<{ isShown: boolean }>`
    box-sizing: content-box;
    width: 100%;
    height: ${({ isShown }) => isShown ? '61px' : '0px'};
    padding-bottom: 9px;
    display: flex;
    justify-content: center;

    position: absolute;
    left: 0;
    bottom: 100%;
    transition: height 0.2s;
  `,
  VolumeBar: styled.div`
    width: 9px;
    height: 100%;
    display: flex;
    align-items: flex-end;
    background: #434343;
    cursor: pointer;
    border-radius: 2px;
    overflow: hidden;
  `,
  Volume: styled.div<{ volume: number }>`
    width: 100%;
    height: ${props => props.volume * 100}%;
    border-radius: 2px;
    background: #FFF;
    transition: height 0.1s;
  `,
  VolumeMuted: styled.img.attrs({ src: VolumeMutedIcon })`
    height: 32px;
    width: 32px;
    cursor: pointer;
  `,
  VolumeOn: styled.img`
    height: 32px;
    width: 32px;
    cursor: pointer;
  `,
}

export { S as default };
